import angular from 'angular';

import header from "./header";
import designPreview from './design-preview';
import doorList from './door-list';
import newDoor from './new-door';
import optionMenu from './option-menu';
import photoUploader from './photo-uploader';
import projectBrowser from './project-browser';
import selectionMenu from './selection-menu';
import quoteRequest from './quote-request';
import emailDesign from './email-design';
import printDesign from './print-design';
import infoWindow from './info-window';
import previewWindow from './preview-window';

export default angular.module('slViz.components', [
    header,
    designPreview,
    doorList,
    newDoor,
    optionMenu,
    photoUploader,
    projectBrowser,
    selectionMenu,
    quoteRequest,
    emailDesign,
    printDesign,
    infoWindow,
    previewWindow
]).name;


// WEBPACK FOOTER //
// ./src/js/components/index.js